import { CheckoutField, TextKey } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';
import { TextInput, TextInputProps } from '@optimus-web/core';

import { createCheckoutFormFieldDataTestId } from '../utils/createCheckoutFormFieldDataTestId';
import { useCheckoutField } from '../utils/hooks';

interface EmailInputProps {
    name: CheckoutField.Email | CheckoutField.BookerEmail;
    helper: React.ReactNode;
    optionalFieldHelper?: React.ReactNode;
}

export const EmailInput = ({ helper, optionalFieldHelper, name }: EmailInputProps) => {
    const { onBlur, onChange, error, customerValue, required } = useCheckoutField(name);

    const handleChange: TextInputProps['onChange'] = (_event, value) => {
        onChange(value.toString().trim());
    };

    return (
        <TextInput
            name={name}
            required={required}
            autoComplete="email"
            label={<LocalizedText textKey={TextKey.Email} />}
            helper={optionalFieldHelper != null && !required ? optionalFieldHelper : helper}
            onChange={handleChange}
            onBlur={onBlur}
            value={customerValue ?? ''}
            error={error != null ? <LocalizedText textKey={error} /> : null}
            data-test-id={createCheckoutFormFieldDataTestId(name)}
        />
    );
};
